export default __webpack_public_path__ + "static/media/swapChain.0c593b14.svg";